import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core'; import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'input-link',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './input-link.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputLinkComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputLinkComponent),
      multi: true,
    },
  ],
})
export class InputLinkComponent implements ControlValueAccessor, Validator, OnInit {
  @Input() label = 'link'; // Default label, can be overridden
  @Input() required = false;
  @Input() requiredLabel = 'link-required';
  @Input() readonly = false;
  @Input() formFieldClass: string = '';


  control = new FormControl<string | null>(null);


  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() {
    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnInit() {
    const validators = [Validators.pattern(/^https:\/\/.*\..+$/)];
    // set the required validator if the selection is required.
    if (this.required) {
      validators.push(Validators.required);
    }
    this.control.setValidators(validators);
  }


  writeValue(value: string | null): void {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.control.valid ? null : this.control.errors;
  }


}
